// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"fb94a351","139":"ec4ce3ab","224":"09646285","400":"79a3c3a4","431":"d51934ba","816":"d7125865","831":"639980fd","911":"4ffef6e3"}[chunkId] + ".chunk.js";
};